import React from 'react';
import HorizontalDivider from '../HorizontalDivider';
import css from './subheading_with_divider.module.scss';

interface SubheadingWithDividerProps {
  heading?: string;
}

export default function SubheadingWithDivider({
  heading
}: SubheadingWithDividerProps) {
  return (
    <>
      <p className={css.headingText}>
        {heading ?? 'Application for Family Cash Card'}
      </p>
      <HorizontalDivider />
    </>
  );
}
